import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import '@/styles/nprogress.less' // progress bar custom style
import { setDocumentTitle } from '@/utils/domUtil'
import projectConfig from '@/config/projectConfig'
import { TOKEN } from '@/store/storage-types'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  'login',
  'register',
  'registerResult',
  'processEditor',
  'formHome',
  'formParser',
  'performanceSubmit', //绩效提交
  'performanceProcess', //绩效审批 | 历史
] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  to.meta &&
    typeof to.meta.title !== 'undefined' &&
    setDocumentTitle(`${to.meta.title} - ${projectConfig.projectTitle}`)
  if (whiteList.includes(to.name)) {
    // 在免登录白名单，直接进入
    next()
  } else if (Vue.ls.get(TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.userRouters.length === 0) {
        store.dispatch('GenerateRoutes').then(() => {
          // 根据roles权限生成可访问的路由表
          // 动态添加可访问路由表
          router.addRoutes(store.getters.userRouters)
          const redirect = decodeURIComponent(from.query.redirect || to.path)
          if (to.path === redirect) {
            // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ path: redirect, replace: true })
          } else {
            // 跳转到目的路由
            next({ path: redirect })
          }
        })
      } else {
        next()
      }
    }
  } else {
    next({ path: '/user/login', query: { redirect: to.fullPath } })
    NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
